@if (item?.isNavigierbar) {
  <cap-link
    [queryParams]="{ id: item.id.id }"
    [target]="navigateTo"
    [tooltipParams]="{ nummer: item.grundstueckNummer | grundstuecknummerExtended }">
    <ng-template [ngTemplateOutlet]="value"></ng-template>
  </cap-link>
} @else {
  {{ item | kompaktGrundstueck: language }}
}

<ng-template #value>
  {{ item | kompaktGrundstueck: language }}
</ng-template>
